import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NewFileList = (props) => {
    const { files, deleteFile } = props;
    const intl = useIntl();

    return(
        <Fragment>
            {files.map((ticket, fileIndex) => {
                return (
                    <div className='grid-row row-file' key={fileIndex}>
                        <div className="mobile:grid-col-12 desktop:grid-col-6">
                            <span>{ticket.name}</span>
                        </div>
                        <div className="mobile:grid-col-12 desktop:grid-col-5">
                            {ticket.size}
                        </div>
                        <div className="mobile:grid-col-12 desktop:grid-col-1">
                            <i title={intl.formatMessage({ id: 'ticket.attachment.button.delete.attachment' })} className="icon-link" onClick={(e) => deleteFile(fileIndex, e)}><FontAwesomeIcon icon="trash-alt" size="1x" /></i>
                        </div>
                    </div>
                );
            })}
        </Fragment>
    );
};

export default NewFileList;